import type { SignatureInfo } from '../pages/appointments/fhirNoteMapping';

const CURSIVE_FONT = "'Brush Script MT', 'Segoe Script', 'Lucida Handwriting', cursive";

export function formatSignatureDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

/** HTML for the read-only client signature block (matches SignatureDisplayBox). */
export function buildClientSignatureBlockHtml(
  signature: SignatureInfo,
  label = 'Client signature',
): string {
  if (!signature.name?.trim() && !signature.signatureData?.trim()) {
    return '';
  }

  const signedAt = signature.signedAt ? formatSignatureDateTime(signature.signedAt) : '';
  const signatureMarkup = signature.signatureData
    ? `<img src="data:${signature.signatureFormat ?? 'image/png'};base64,${signature.signatureData}" alt="Signature of ${signature.name}" style="max-height:60px;max-width:100%;object-fit:contain;display:block;margin-top:8px;" />`
    : `<div style="font-family:${CURSIVE_FONT};font-size:20px;font-weight:600;color:#343a40;margin-top:8px;">${signature.name}</div>`;

  const license = signature.license
    ? `<div style="font-size:13px;color:#495057;margin-top:6px;white-space:pre-line;">${signature.license}</div>`
    : '';
  const title = signature.title
    ? `<div style="font-size:12px;color:#495057;margin-top:4px;">${signature.title}</div>`
    : '';
  const signedAtMarkup = signedAt
    ? `<div style="font-size:12px;color:#868e96;margin-top:6px;">${signedAt}</div>`
    : '';

  return `
    <div class="signature-display-box" style="margin-top:16px;padding:16px;background:#e7f5ff;border-radius:8px;min-height:120px;">
      <div style="font-size:12px;color:#868e96;margin-bottom:6px;">${label}</div>
      ${signatureMarkup}
      ${license}
      ${title}
      ${signedAtMarkup}
    </div>`;
}
